export const PDP_DISPLAY_PRICE_SIMPLE_TYPE = 'simple';
